import { Box } from '@mui/material';
import { ResponsiveHeatMap } from '@nivo/heatmap';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

const MONTH_INDEX = {
    Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
    Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
};

export default function SeasonalHeatmap({ data }) {
    const { theme } = useNivoTheme();
    if (!data?.data || data.data.length === 0) return null;

    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();

    const isFuture = (year, monthLabel) => {
        const y = parseInt(year, 10);
        const m = MONTH_INDEX[monthLabel];
        if (Number.isNaN(y) || m == null) return false;
        return y > currentYear || (y === currentYear && m > currentMonth);
    };

    const heatmapData = data.data.map(row => ({
        id: row.id,
        data: data.keys.map(year => ({
            x: year,
            y: isFuture(year, row.id) ? null : (row[year] || 0),
        })),
    }));

    return (
        <ChartSection
            id="seasonal"
            title="Are there seasonal patterns in congressional trading?"
            subtitle="Monthly trading volume by year — darker = more trades"
        >
            <Box sx={{ height: 420 }}>
                <ResponsiveHeatMap
                    data={heatmapData}
                    margin={{ top: 40, right: 30, bottom: 30, left: 55 }}
                    axisTop={{ tickRotation: -30 }}
                    axisLeft={{}}
                    colors={{ type: 'sequential', scheme: 'purples' }}
                    emptyColor="rgba(255,255,255,0.03)"
                    borderRadius={2}
                    borderWidth={1}
                    borderColor="rgba(255,255,255,0.06)"
                    labelTextColor="#ffffff"
                    tooltip={({ cell }) => (
                        <ChartTooltip
                            title={`${cell.serieId} ${cell.data.x}`}
                            rows={[
                                {
                                    label: 'Trades',
                                    value:
                                        cell.data.y == null
                                            ? '— (future)'
                                            : cell.data.y.toLocaleString(),
                                    color: cell.color,
                                },
                            ]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
